export default __webpack_public_path__ + "static/media/single-project-page-01-img5.0c9822be.jpg";